<template>
  <section class="section-shaped">
    <div :class="'shape bg-'+color+' shape-'+color+' shape-skew' + (alt ? '-alt':'-norm')"></div>
    <div class="container shape-container">
      <div class="text-center">
        <div class="h2 text-white text-uppercase">{{ title }}</div>
        <p class="lead text-white w-75 mx-auto">{{ subtitle }}</p>
      </div>
      <div class="row text-center">
        <panel-card
          v-for="(c, idx) in cards"
          :key="idx"
          :icon="c.icon"
          :icons="c.icons"
          :size="c.size"
          :title="c.title"
          :text="c.text"
          :color="color"
        ></panel-card>
      </div>
      <div class="w-75 mx-auto pb-md">
        <div class="lead text-center text-white">{{ text }}</div>
      </div>
    </div>
  </section>
</template>
<script>
import PanelCard from "./DisplayPanelCard";
export default {
  components: {
    PanelCard
  },
  props: {
    title: {
      type: String,
      default: ""
    },
    subtitle: {
      type: String,
      default: ""
    },
    text: {
      type: String,
      default: ""
    },
    color: {
      type: String,
      default: "dark"
    },
    alt: {
      type: Boolean,
      default: false
    },
    cards: {
      type: Array,
      default: function() {
        return [];
      }
    }
  }
};
</script>
